export var Create = 1;
export var Index = 2;
export var Show = 3;
export var Update = 4;
export var SupplierTypes = 5;
export var MiniIndex = 6;
export var BulkInsert = 7;
export var ClosePeriod = 8;
export var CreatePatientTransaction = 9;
export var Revert = 10;
export var MetaInfo = 11;
export var Refund = 12;
export var ListAllData = 13;
export var MarkAsPending = 14;
export var MarkAsUnReached = 15;
export var MarkAsConfirmed = 16;
export var MarkAsLate = 17;
export var MarkAsWaiting = 18;
export var MarkAsInVisit = 19;
export var MarkAsAfterWork = 20;
export var MarkAsFinished = 21;
export var MarkAsCancelled = 22;
export var BulkCreate = 23;
export var Void = 24;
export var UpdateAvailability = 25;
export var Prices = 26;
export var Entities = 27;
export var Appointments = 28;
export var CurrentInVisitAppointment = 29;
export var SearchByPhone = 30;
export var PackageReports = 31;
export var DoctorReports = 32;
export var PatientReports = 33;
export var ClinicReports = 34;
export var ChangeEmail = 35;
export var ChangePassword = 36;
export var Languages = 37;
export var ChangeLanguage = 37;
export var Permissions = 39;
export var MiniList = 40;
export var Audit = 41;
export var UpdateConfig = 42;
export var Current = 43;
export var AssignEmployees = 44;
export var AddMedicalMachine = 45;
export var RemoveMedicalMachine = 46;
export var AddItem = 49;
export var EditItem = 50;
export var RemoveItem = 51;
export var AppendStep = 52;
export var Transition = 53;
export var TransitionStep = 54;
export var CollectPayment = 55;
export var FulfillItem = 56;
export var AssignClinic = 57;
export var UnassignClinic = 58;
export var Queue = 59;
